import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { l } from "../functions";

class RemovePageDialog extends Component {
  render() {
    return (
      <Dialog
        open={this.props.open ? true : false}
        onClose={this.props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
        <DialogContent style={{ height: 100 }}>
          <DialogContentText id="alert-dialog-description">
            {l("Are you sure to delete the theme permanently?")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            onClick={this.props.onConfirm}
            style={{ backgroundColor: "#CCCEDC" }}
          >
            <span style={{ color: "#292B49" }}>{l("Yes")}</span>
          </button>
          <button onClick={this.props.onClose}>
            <span>{l("No")}</span>
          </button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default RemovePageDialog;
